module.exports = __webpack_public_path__ + "img/cai6.1042f5bb.png";